export function resolveGameUrl(url: string, name: string): string {
  if (process.env.NODE_ENV === 'production') {
    return url;
  }
  try {
    const remote = new URL(url);
    return `/games/${name}/index.html${remote.search}`;
  } catch {
    return url;
  }
}
